export enum MailFolder {
	Inbox,
	Sent,
	Draft,
	CyberBox
}